import React, { useState, useRef, useCallback, useEffect } from "react";
import { useSelector } from "react-redux";
import TYPE from "../../../constant/TYPE";
import useLaTexCode from "../../../hooks/useLaTexCode";

const CheckWrongAnswerNode = ( props ) => {

  const [ chtml, setCHTML ] = useState( '' );

  const container = useRef();

  const mathjax = useSelector( state => state.mathjax );

  const { correctImgCode } = useLaTexCode();

  useEffect( () => {
    if ( mathjax.target ) {
      const correctedImgCode = correctImgCode( props.children );
      const metrics = mathjax.target.getMetricsFor( container.current, true );
      const chtml = mathjax.target.tex2chtml( correctedImgCode, metrics );
      setCHTML( chtml.outerHTML );
    }
  }, [ mathjax.target, props.children ] );

  useEffect( () => {
    if ( chtml ) {
      highlightingAnswerArea();
      mathjax.target.typeset();
      mathjax.target.typesetPromise( [ container.current ] ).then( complete );
    }
  }, [ chtml ] );

  const highlightingAnswerArea = useCallback( () => {
    const highlight = ( target ) => {
      const mjxBox = target.closest( 'mjx-box' );
      const answerArea = mjxBox?.nextSibling || mjxBox || target.closest( 'mjx-mtd' ) || target.closest( '.numberline-num' ) || target.closest( '.inputTxt' ) || target.closest( '.td_box' );
      answerArea && answerArea.classList.add( 'my-ans' );
    };
    container.current.querySelectorAll( `[ id*=${ TYPE.ID.ANSWER_AREA } ]` ).forEach( highlight );
  }, [] );

  const complete = useCallback( () => {
    props.onRender( container.current, props.index );
  }, [ props.index, props.onRender ] );

  return <div ref={ container } dangerouslySetInnerHTML={ { __html : chtml } } />;

};

CheckWrongAnswerNode.defaultProps = {
  onRender : () => {}
};

export default CheckWrongAnswerNode;
